import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import socialPrintTemplateStrings from './contextualStrings';
import ContextualString from '../../../../../../../../components/contextual/ContextualString';
import { isAlbumFolderParentPay } from '../helpers';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    join_code: PropTypes.string,
    is_web_gallery: PropTypes.bool,
    album_subtype: PropTypes.string.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    id: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    organization_name: PropTypes.string.isRequired,
  }).isRequired,
};

const SocialPrintTemplatePFJoinCode = ({ albumFolder, account }) => {
  const stringId = isAlbumFolderParentPay(albumFolder)
    ? 'parentPayMainCopy'
    : 'photoFinderMainCopy';

  return (
    <Fragment>
      <p className="marketing-material-social-main-copy">
        <ContextualString
          id={stringId}
          defaultMessage="{orgName} is excited to announce we’re offering Waldo’s facial recognition powered mobile app to deliver photos to you! You’ll be able to sit back and relax while Waldo delivers YOUR photos to you and your family members for FREE!"
          type={albumFolder.album_type}
          subtype={albumFolder.album_subtype}
          strings={socialPrintTemplateStrings}
          values={{
            orgName: account.organization_name,
          }}
        />
      </p>
      <p className="marketing-material-social-cta-copy">
        Text this code to 735-343:
      </p>
      <p className="marketing-material-social-target-copy text-uppercase">
        {albumFolder.join_code}
      </p>
      {albumFolder.is_web_gallery && (
        <Fragment>
          <p className="marketing-material-social-footer-or">or</p>
          <p className="marketing-material-social-footer-copy">
            Visit{' '}
            <span>
              <a href="https://waldophotos.com/galleries">
                waldophotos.com/galleries
              </a>
            </span>{' '}
            and enter the Join Code above to view your photos on the web!
          </p>
        </Fragment>
      )}
    </Fragment>
  );
};

SocialPrintTemplatePFJoinCode.propTypes = propTypes;

export default SocialPrintTemplatePFJoinCode;
